import React from 'react';
import {Row, Col, Card, CardBody} from 'reactstrap';

import {FaEdit} from 'react-icons/fa';
import {MdDeleteForever} from 'react-icons/md';

const AddSaleRow = ({data, index, edit, del, ...props}) => {
    return(
        <Row className='mb-2'>
            <Col xs={1}>{index + 1}</Col>
            <Col xs={2}>{data.productName}</Col>
            <Col xs={1}>{data.qty + " " + data.unitName}</Col>
            <Col xs={1}>&#8377; {Number(data.rate).toFixed(2)}</Col>
            <Col xs={1}>&#8377; {Number(Number(data.rate) * Number(data.qty)).toFixed(2)}</Col>
            <Col xs={1}><FaEdit className="cursor" color="#FFC000" size={20} onClick={edit} /></Col>
            <Col xs={1}><MdDeleteForever className="cursor" color="#ff4136" size={20} onClick={del} /></Col>
        </Row>
    )
}
export default AddSaleRow;